import React from 'react';
import { IInfoCluster } from '@mayfield/sanity';
import {
  IntersectionAnimation,
  LayoutProvider
} from '@mayfield/common/components';
import cn from 'classnames';
import * as styles from './styles.module.scss';
import Cluster from './components/Cluster';

interface IProps {
  infoClusters: IInfoCluster[];
  title?: string;
  id?: string;
}

const InfoClusters = ({ infoClusters, id, title }: IProps) => {
  const is3Columns = () => {
    const numberOfItems = infoClusters.length;

    if (numberOfItems % 4 === 0) return false;
    if (numberOfItems % 3 === 0) return true;
    if (numberOfItems % 6 === 1) return false;
    if (numberOfItems > 4) return true;
    return false;
  };

  return (
    <div className={styles.container} id={id}>
      <LayoutProvider maxWidth padding>
        {title && <h2 className={cn('h1', styles.title)}>{title}</h2>}

        <div
          className={cn(styles.clusters, {
            [styles.threeCol]: is3Columns()
          })}
        >
          {infoClusters.map((cluster, i) => (
            <IntersectionAnimation
              key={i}
              delay={100 + i * 100}
              animation="fadeGrow"
            >
              <Cluster className={styles.cluster} {...cluster} />
            </IntersectionAnimation>
          ))}
        </div>
      </LayoutProvider>
    </div>
  );
};

export default InfoClusters;
